// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add & Edit Contact Styling - Pixel-Perfect Figma Implementation (1564:163430, 1557:88179, 1569:88250, 1591:151187, 1591:151462) */

.add-contact-page {
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font-family: "Lexend", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  box-sizing: border-box;
}

.add-contact-page .dashboard-main {
  flex: 1 1;
  min-width: 0;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
}

.add-contact-content {
  padding: 32px 24px 64px 32px;
  max-width: 100%;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.add-contact-editor-bar {
  min-height: 72px;
  padding: 16px 32px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
  background: var(--surface-primary, #fff);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.add-contact-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 13px;
  line-height: normal;
}

.add-contact-breadcrumb a {
  color: var(--text-tertiary, #6b7b78);
  text-decoration: none;
}

.add-contact-breadcrumb svg {
  width: 14px;
  height: 14px;
  color: var(--text-tertiary, #6b7b78);
}

.add-contact-breadcrumb span {
  color: var(--text-primary, #142624);
  font-weight: 500;
}

/* Header & Back Link */
.add-contact-abr-results {
  display: grid;
  gap: var(--space-3);
  padding: 0;
  margin: 0;
  list-style: none;
  overflow-wrap: anywhere;
}

.add-contact-abr-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  margin-top: var(--space-2);
}

.add-contact-abr-trigger {
  align-self: flex-start;
  min-height: 40px;
  margin-top: 2px;
  padding: 0 16px;
  font-size: 13px;
}

.add-contact-abr-feedback:not(:empty) {
  width: 100%;
  max-height: 260px;
  margin-top: 4px;
  padding: 12px;
  overflow: auto;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  background: var(--surface-primary, #fff);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(14, 26, 32, 0.08));
}

.add-contact-field-group > .add-contact-abr-actions {
  gap: 12px;
  margin-top: 2px;
}

.add-contact-field-group > .add-contact-abr-actions .add-contact-btn-save,
.add-contact-field-group > .add-contact-abr-actions .add-contact-abr-link {
  min-height: 40px;
  height: 40px;
  padding: 0 16px;
  font-size: 13px;
}

.add-contact-rcti-settings {
  width: 532px;
  max-width: 100%;
  margin: 2px 0 0;
  padding: 14px 16px 16px;
  border: 1px solid var(--border-default, #c8d3d1);
  border-radius: 10px;
  color: var(--text-primary, #142624);
}

.add-contact-rcti-settings legend {
  padding: 0 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.add-contact-rcti-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 16px;
}

.add-contact-abr-message {
  margin: 0 0 var(--space-3);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  line-height: 1.5;
}

.add-contact-abr-business {
  display: flex;
  flex: 1 1 220px;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
}

.add-contact-abr-business strong {
  color: var(--text-primary);
  font-size: var(--font-size-body-sm);
  line-height: 1.5;
}

.add-contact-abr-meta {
  color: var(--text-secondary);
  font-size: var(--font-size-body-xs);
  line-height: 1.5;
}

.add-contact-abr-status {
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-pill);
  background: var(--surface-tertiary);
  color: var(--text-secondary);
  font-size: var(--font-size-body-xs);
  font-weight: 500;
}

.add-contact-abr-status.is-active {
  background: var(--success-soft);
  color: var(--success-text);
}

.add-contact-page a.add-contact-abr-link {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: var(--space-2);
  box-sizing: border-box;
  min-height: var(--control-md);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--interactive-default);
  border-radius: var(--radius-sm);
  background-color: var(--interactive-soft);
  color: var(--interactive-default);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.add-contact-page a.add-contact-abr-link:hover {
  background-color: var(--interactive-soft-hover);
  border-color: var(--interactive-hover);
  color: var(--interactive-hover);
}

.add-contact-page a.add-contact-abr-link:focus-visible {
  outline: 2px solid var(--interactive-default);
  outline-offset: 2px;
}

.add-contact-abr-results li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
}

.add-contact-page .add-contact-btn-cancel:disabled,
.add-contact-page .add-contact-abr-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.add-contact-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  min-height: 63px;
}

.add-contact-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  background: transparent;
  color: var(--interactive-default, #0f766e);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
  width: -moz-fit-content;
  width: fit-content;
}

.add-contact-back-btn:hover {
  background-color: var(--interactive-soft, #f0f8f7);
}

.add-contact-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.add-contact-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.36px;
  color: var(--text-primary, #142624);
}

.add-contact-subtitle {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.065px;
}

.add-contact-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Card Form Container */
.add-contact-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Individual Form Section Card */
.add-contact-card {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  gap: 24px;
  align-items: flex-start;
  box-sizing: border-box;
}

/* Left Column: Intro Title & Subtitle */
.add-contact-card-intro {
  width: 170px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.add-contact-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  color: var(--text-primary, #142624);
}

.add-contact-card-desc {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--text-secondary, #506360);
}

/* Right Column: Fields Container */
.add-contact-card-fields {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 896px;
}

.add-contact-card--logo .add-contact-card-intro {
  width: 103px;
}

/* Grid & Flex Rows for Inputs */
.add-contact-field-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.add-contact-field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
}

.add-contact-select-field {
  gap: 4px;
}

.add-contact-field-group.w-full {
  width: 100%;
}

.add-contact-field-group.w-532 {
  width: 532px;
  max-width: 100%;
}

.add-contact-field-group.w-260 {
  width: 260px;
  max-width: 100%;
}

.add-contact-field-group.w-160 {
  width: 160px;
  max-width: 100%;
}

.add-contact-field-group.w-200 {
  width: 200px;
  max-width: 100%;
}

.add-contact-field-group.flex-1 {
  flex: 1 1;
  min-width: 180px;
}

/* Labels */
.add-contact-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #142624);
  line-height: 18px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.add-contact-required-star {
  color: var(--danger-default, #c23a2b);
}

/* Form Inputs, Selects, and Textareas */
.add-contact-input,
.add-contact-select {
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  background-color: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
  width: 100%;
}

.contact-theme-select {
  position: relative;
  width: 100%;
}

.contact-theme-select.is-open {
  z-index: 40;
}

.contact-theme-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 40px;
  padding: 0 10px 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 21.7px;
  text-align: left;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.contact-theme-select-trigger:hover {
  border-color: var(--text-secondary, #506360);
}

.contact-theme-select.is-open .contact-theme-select-trigger,
.contact-theme-select-trigger:focus-visible {
  border: 2px solid var(--interactive-default, #0f766e);
  padding-inline: 11px 9px;
  box-shadow: none;
}

.contact-theme-select-trigger span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contact-theme-select-trigger svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  transition: transform 0.15s ease;
}

.contact-theme-select.is-open .contact-theme-select-trigger svg {
  transform: rotate(180deg);
}

.contact-theme-select-menu {
  position: absolute;
  z-index: 50;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 240px;
  padding: 6px;
  overflow-y: auto;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.16),
    0 1px 2px rgba(14, 26, 32, 0.06);
}

.contact-theme-select-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 36px;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary, #142624);
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
  outline: none;
}

.contact-theme-select-option:hover,
.contact-theme-select-option.is-active,
.contact-theme-select-option.is-selected,
.contact-theme-select-option:focus-visible {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}

.contact-theme-select-option svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}

.add-contact-input:focus,
.add-contact-select:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

.add-contact-input::placeholder {
  color: var(--text-disabled, #8a9896);
}

.add-contact-textarea {
  min-height: 118px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  background-color: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-size: 14px;
  font-family: inherit;
  outline: none;
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
  width: 100%;
}

.add-contact-textarea:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}

/* Error States (Figma 1591:151187) */
.add-contact-input.has-error,
.add-contact-select.has-error,
.add-contact-textarea.has-error {
  border-color: var(--danger-default, #c23a2b) !important;
}

.add-contact-error-msg {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: var(--danger-default, #c23a2b);
}

/* Switch Toggle (Billing Section) */
.add-contact-toggle-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  height: 28px;
}

.add-contact-reminders {
  width: 300px;
  gap: 4px;
}

.add-contact-reminders .add-contact-label {
  color: var(--text-secondary, #506360);
  line-height: 16.9px;
}

.add-contact-toggle-switch {
  position: relative;
  width: 40px;
  height: 22px;
  background-color: var(--border-default, #cdd6d4);
  border-radius: 999px;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.add-contact-toggle-switch.is-on {
  background-color: var(--interactive-default, #0f766e);
}

.add-contact-toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.add-contact-toggle-switch.is-on .add-contact-toggle-thumb {
  transform: translateX(18px);
}

.add-contact-toggle-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary, #142624);
}

/* Address Accordion Disclosure */
.add-contact-accordion-header {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 0;
  background: transparent;
  border: none;
  color: var(--text-primary, #142624);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  width: 100%;
}

.add-contact-accordion-header::after {
  content: "";
  flex: 1 1;
  height: 1px;
  margin-left: 4px;
  background: var(--border-subtle, #dce3e2);
}

.add-contact-accordion-header:hover {
  color: var(--interactive-default, #0f766e);
}

.add-contact-accordion-header svg {
  font-size: 18px;
  transition: transform 0.2s ease;
}

.add-contact-accordion-header.expanded svg {
  transform: rotate(90deg);
}

/* Manual Address Panel (1569:88250) */
.add-contact-manual-address-panel {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 4px;
}

/* Logo Upload & Preview */
.add-contact-logo-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.add-contact-logo-preview {
  width: 75px;
  height: 75px;
  border-radius: 12px;
  border: 1px dashed var(--border-default, #cdd6d4);
  background-color: var(--surface-secondary, #f4f7f7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.add-contact-logo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.add-contact-logo-placeholder-icon {
  width: 24px;
  height: 24px;
  color: var(--text-disabled, #8a9896);
}

.add-contact-logo-placeholder-text {
  font-size: 11px;
  color: var(--text-secondary, #506360);
}

.add-contact-logo-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.add-contact-logo-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-contact-logo-hint {
  margin: 0;
  font-size: 12px;
  color: var(--text-secondary, #506360);
}

/* Buttons */
.add-contact-btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  background-color: var(--surface-primary, #ffffff);
  color: var(--text-primary, #142624);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease;
}

.add-contact-btn-cancel:hover {
  background-color: var(--surface-tertiary, #e8edec);
  border-color: var(--border-strong, #8b9996);
  color: var(--text-primary, #142624);
}

.add-contact-btn-save,
.add-contact-btn-save:link,
.add-contact-btn-save:visited {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  border: none;
  background-color: var(--interactive-default, #0f766e);
  color: #ffffff !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.15s ease;
}

.add-contact-btn-save:hover {
  background-color: var(--interactive-hover, #0a655f);
  color: #ffffff !important;
}

.add-contact-btn-save:active {
  background-color: var(--interactive-pressed, #084f4b);
  color: #ffffff !important;
}

.add-contact-btn-save svg {
  color: #ffffff !important;
  stroke: #ffffff !important;
}

/* Dark mode button themes */
.add-contact-page.dark .add-contact-btn-save,
.add-contact-page[data-theme="dark"] .add-contact-btn-save {
  background-color: var(--interactive-default, #43a79c);
  color: #101113 !important;
  font-weight: 600;
}

.add-contact-page.dark .add-contact-btn-save svg,
.add-contact-page[data-theme="dark"] .add-contact-btn-save svg {
  color: #101113 !important;
  stroke: #101113 !important;
}

.add-contact-page.dark .add-contact-btn-save:hover,
.add-contact-page[data-theme="dark"] .add-contact-btn-save:hover {
  background-color: var(--interactive-hover, #83c7be);
  color: #101113 !important;
}

.add-contact-page.dark .add-contact-btn-save:active,
.add-contact-page[data-theme="dark"] .add-contact-btn-save:active {
  background-color: var(--interactive-pressed, #b6ded8);
  color: #101113 !important;
}

.add-contact-page.dark .add-contact-btn-cancel {
  background-color: var(--surface-primary, #191b1f);
  border-color: var(--border-default, #3a3f47);
  color: var(--text-primary, #f2f3f5);
}

.add-contact-page.dark .add-contact-btn-cancel:hover,
.add-contact-page[data-theme="dark"] .add-contact-btn-cancel:hover {
  background-color: var(--surface-tertiary, #2b2f35);
  border-color: var(--border-strong, #69727e);
  color: var(--text-primary, #f2f3f5);
}

.add-contact-btn-save:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Spinner for button loading */
.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Duplicate Contact Modal (1591:151462) */
.duplicate-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: var(--overlay-default, rgba(10, 22, 20, 0.44));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}

.duplicate-modal-dialog {
  background-color: var(--surface-primary, #ffffff);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 20px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),
    0px 1px 1px rgba(14, 26, 32, 0.04);
  overflow: hidden;
  animation: modalFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.duplicate-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 28px 28px 20px;
}

.duplicate-modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.duplicate-modal-icon {
  font-size: 24px;
  color: var(--warning-default, #b7701a);
  display: flex;
}

.duplicate-modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary, #142624);
}

.duplicate-modal-close {
  border: none;
  background: transparent;
  color: var(--text-secondary, #506360);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  padding: 4px;
  border-radius: 6px;
}

.duplicate-modal-divider {
  height: 1px;
  background-color: var(--border-subtle, #dce3e2);
  width: 100%;
}

.duplicate-modal-body {
  padding: 24px 28px 0;
}

.duplicate-modal-body p {
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--text-secondary, #506360);
}

.duplicate-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 28px;
}

/* Responsive adjustments */
@media (max-width: 1024px) {
  .add-contact-page .dashboard-main {
    margin-left: 0;
  }
}

@media (max-width: 900px) {
  .add-contact-card {
    flex-direction: column;
    gap: 16px;
  }
  .add-contact-card-intro {
    width: 100%;
  }
  .add-contact-field-group.w-532,
  .add-contact-field-group.w-260,
  .add-contact-field-group.w-160 {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .add-contact-content {
    padding: 20px 16px 112px;
  }

  .add-contact-header {
    gap: 12px;
    margin-bottom: 20px;
  }

  .add-contact-title-row {
    align-items: flex-start;
  }

  .add-contact-title {
    font-size: 20px;
    line-height: 26px;
    letter-spacing: -0.2px;
  }

  .add-contact-actions {
    position: fixed;
    z-index: 20;
    right: 0;
    bottom: 0;
    left: 0;
    gap: 12px;
    padding: 16px 24px 28px;
    border-top: 1px solid var(--border-subtle, #dce3e2);
    background: var(--surface-primary, #fff);
  }

  .add-contact-actions .add-contact-btn-cancel {
    flex: 0 0 100px;
  }

  .add-contact-actions .add-contact-btn-save {
    flex: 1 1;
  }

  .add-contact-form {
    gap: 16px;
  }

  .add-contact-card {
    gap: 16px;
    padding: 20px;
    border-radius: 10px;
  }

  .add-contact-card-fields,
  .add-contact-field-row {
    gap: 16px;
  }

  .add-contact-rcti-grid {
    grid-template-columns: 1fr;
  }

  .add-contact-abr-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .add-contact-field-group > .add-contact-abr-actions .add-contact-btn-save,
  .add-contact-field-group > .add-contact-abr-actions .add-contact-abr-link {
    width: 100%;
    justify-content: center;
  }

  .add-contact-field-group,
  .add-contact-field-group.w-532,
  .add-contact-field-group.w-260,
  .add-contact-field-group.w-200,
  .add-contact-field-group.w-160,
  .add-contact-field-group.flex-1 {
    width: 100%;
    min-width: 0;
  }

  .duplicate-modal-overlay,
  .contact-modal-overlay {
    align-items: flex-end;
    padding: 64px 0 0;
    background: var(--overlay-default, rgba(0, 0, 0, 0.6));
  }

  .duplicate-modal-dialog,
  .contact-modal-dialog {
    position: relative;
    max-width: none !important;
    min-height: 350px;
    border: 0;
    border-radius: 20px 20px 0 0;
  }

  .duplicate-modal-dialog::before,
  .contact-modal-dialog::before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 8px;
    left: 50%;
    width: 40px;
    height: 4px;
    border-radius: 999px;
    background: var(--border-subtle, #dce3e2);
    transform: translateX(-50%);
  }

  .duplicate-modal-header,
  .contact-modal-header {
    min-height: 80px;
    padding: 20px 24px 0;
    border-bottom: 1px solid var(--border-subtle, #dce3e2);
  }

  .duplicate-modal-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 22.4px;
    letter-spacing: -0.08px;
  }

  .duplicate-modal-icon {
    font-size: 24px;
  }

  .duplicate-modal-divider {
    display: none;
  }

  .duplicate-modal-body,
  .contact-modal-body {
    min-height: 102px;
    padding: 18px 24px;
  }

  .duplicate-modal-body p,
  .contact-modal-body p {
    font-size: 13px;
    line-height: 20.2px;
  }

  .duplicate-modal-footer,
  .contact-modal-footer {
    flex-direction: column;
    gap: 12px;
    padding: 16px 24px 28px;
    border-top: 1px solid var(--border-subtle, #dce3e2);
  }

  .duplicate-modal-footer > *,
  .contact-modal-footer > * {
    width: 100%;
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Contacts/addContact.css"],"names":[],"mappings":"AAAA,oIAAoI;;AAEpI;EACE,aAAa;EACb,iBAAiB;EACjB,4CAA4C;EAC5C,mCAAmC;EACnC;cACY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,gDAAgD;EAChD,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,sCAAsC;EACtC,4CAA4C;EAC5C,+BAA+B;EAC/B,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,uCAAuC;EACvC,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wCAAwC;AACxC;;EAEE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,iDAAiD;EACjD,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,0DAA0D;EAC1D,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,qDAAqD;EACrD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC;oCACkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;;;;EAIE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,iDAAiD;EACjD,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,0DAA0D;EAC1D,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;;;EAGE,uDAAuD;AACzD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,oBAAoB;EACpB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qCAAqC;AACvC;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,iDAAiD;EACjD,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;;EAEE,qDAAqD;EACrD,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;;EAEE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;;EAEE,kDAAkD;EAClD,2CAA2C;EAC3C,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,gEAAgE;EAChE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB;sCACoC;EACpC,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;;;IAGE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,QAAQ;IACR,SAAS;IACT,OAAO;IACP,SAAS;IACT,uBAAuB;IACvB,mDAAmD;IACnD,wCAAwC;EAC1C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;;;;;;IAME,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,qBAAqB;IACrB,iBAAiB;IACjB,sDAAsD;EACxD;;EAEA;;IAEE,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,SAAS;IACT,4BAA4B;EAC9B;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA;;IAEE,gBAAgB;IAChB,oBAAoB;IACpB,sDAAsD;EACxD;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,mDAAmD;EACrD;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* Add & Edit Contact Styling - Pixel-Perfect Figma Implementation (1564:163430, 1557:88179, 1569:88250, 1591:151187, 1591:151462) */\n\n.add-contact-page {\n  display: flex;\n  min-height: 100vh;\n  background-color: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font-family: \"Lexend\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    sans-serif;\n  box-sizing: border-box;\n}\n\n.add-contact-page .dashboard-main {\n  flex: 1;\n  min-width: 0;\n  margin-left: 256px;\n  display: flex;\n  flex-direction: column;\n}\n\n.add-contact-content {\n  padding: 32px 24px 64px 32px;\n  max-width: 100%;\n  width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.add-contact-editor-bar {\n  min-height: 72px;\n  padding: 16px 32px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  background: var(--surface-primary, #fff);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.add-contact-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  font-size: 13px;\n  line-height: normal;\n}\n\n.add-contact-breadcrumb a {\n  color: var(--text-tertiary, #6b7b78);\n  text-decoration: none;\n}\n\n.add-contact-breadcrumb svg {\n  width: 14px;\n  height: 14px;\n  color: var(--text-tertiary, #6b7b78);\n}\n\n.add-contact-breadcrumb span {\n  color: var(--text-primary, #142624);\n  font-weight: 500;\n}\n\n/* Header & Back Link */\n.add-contact-abr-results {\n  display: grid;\n  gap: var(--space-3);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  overflow-wrap: anywhere;\n}\n\n.add-contact-abr-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--space-3);\n  margin-top: var(--space-2);\n}\n\n.add-contact-abr-trigger {\n  align-self: flex-start;\n  min-height: 40px;\n  margin-top: 2px;\n  padding: 0 16px;\n  font-size: 13px;\n}\n\n.add-contact-abr-feedback:not(:empty) {\n  width: 100%;\n  max-height: 260px;\n  margin-top: 4px;\n  padding: 12px;\n  overflow: auto;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  background: var(--surface-primary, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(14, 26, 32, 0.08));\n}\n\n.add-contact-field-group > .add-contact-abr-actions {\n  gap: 12px;\n  margin-top: 2px;\n}\n\n.add-contact-field-group > .add-contact-abr-actions .add-contact-btn-save,\n.add-contact-field-group > .add-contact-abr-actions .add-contact-abr-link {\n  min-height: 40px;\n  height: 40px;\n  padding: 0 16px;\n  font-size: 13px;\n}\n\n.add-contact-rcti-settings {\n  width: 532px;\n  max-width: 100%;\n  margin: 2px 0 0;\n  padding: 14px 16px 16px;\n  border: 1px solid var(--border-default, #c8d3d1);\n  border-radius: 10px;\n  color: var(--text-primary, #142624);\n}\n\n.add-contact-rcti-settings legend {\n  padding: 0 4px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.add-contact-rcti-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px 16px;\n}\n\n.add-contact-abr-message {\n  margin: 0 0 var(--space-3);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.5;\n}\n\n.add-contact-abr-business {\n  display: flex;\n  flex: 1 1 220px;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-2);\n}\n\n.add-contact-abr-business strong {\n  color: var(--text-primary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.5;\n}\n\n.add-contact-abr-meta {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-xs);\n  line-height: 1.5;\n}\n\n.add-contact-abr-status {\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-pill);\n  background: var(--surface-tertiary);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-xs);\n  font-weight: 500;\n}\n\n.add-contact-abr-status.is-active {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n\n.add-contact-page a.add-contact-abr-link {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  gap: var(--space-2);\n  box-sizing: border-box;\n  min-height: var(--control-md);\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--interactive-default);\n  border-radius: var(--radius-sm);\n  background-color: var(--interactive-soft);\n  color: var(--interactive-default);\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.add-contact-page a.add-contact-abr-link:hover {\n  background-color: var(--interactive-soft-hover);\n  border-color: var(--interactive-hover);\n  color: var(--interactive-hover);\n}\n\n.add-contact-page a.add-contact-abr-link:focus-visible {\n  outline: 2px solid var(--interactive-default);\n  outline-offset: 2px;\n}\n\n.add-contact-abr-results li {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n}\n\n.add-contact-page .add-contact-btn-cancel:disabled,\n.add-contact-page .add-contact-abr-actions button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.add-contact-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n  min-height: 63px;\n}\n\n.add-contact-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--interactive-default, #0f766e);\n  font-size: 13px;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  width: fit-content;\n}\n\n.add-contact-back-btn:hover {\n  background-color: var(--interactive-soft, #f0f8f7);\n}\n\n.add-contact-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.add-contact-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 30px;\n  letter-spacing: -0.36px;\n  color: var(--text-primary, #142624);\n}\n\n.add-contact-subtitle {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n  letter-spacing: 0.065px;\n}\n\n.add-contact-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Card Form Container */\n.add-contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Individual Form Section Card */\n.add-contact-card {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  padding: 20px;\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  box-sizing: border-box;\n}\n\n/* Left Column: Intro Title & Subtitle */\n.add-contact-card-intro {\n  width: 170px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.add-contact-card-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 21px;\n  color: var(--text-primary, #142624);\n}\n\n.add-contact-card-desc {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Right Column: Fields Container */\n.add-contact-card-fields {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: 896px;\n}\n\n.add-contact-card--logo .add-contact-card-intro {\n  width: 103px;\n}\n\n/* Grid & Flex Rows for Inputs */\n.add-contact-field-row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.add-contact-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  position: relative;\n}\n\n.add-contact-select-field {\n  gap: 4px;\n}\n\n.add-contact-field-group.w-full {\n  width: 100%;\n}\n\n.add-contact-field-group.w-532 {\n  width: 532px;\n  max-width: 100%;\n}\n\n.add-contact-field-group.w-260 {\n  width: 260px;\n  max-width: 100%;\n}\n\n.add-contact-field-group.w-160 {\n  width: 160px;\n  max-width: 100%;\n}\n\n.add-contact-field-group.w-200 {\n  width: 200px;\n  max-width: 100%;\n}\n\n.add-contact-field-group.flex-1 {\n  flex: 1;\n  min-width: 180px;\n}\n\n/* Labels */\n.add-contact-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-primary, #142624);\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.add-contact-required-star {\n  color: var(--danger-default, #c23a2b);\n}\n\n/* Form Inputs, Selects, and Textareas */\n.add-contact-input,\n.add-contact-select {\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background-color: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.contact-theme-select {\n  position: relative;\n  width: 100%;\n}\n\n.contact-theme-select.is-open {\n  z-index: 40;\n}\n\n.contact-theme-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  height: 40px;\n  padding: 0 10px 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21.7px;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.contact-theme-select-trigger:hover {\n  border-color: var(--text-secondary, #506360);\n}\n\n.contact-theme-select.is-open .contact-theme-select-trigger,\n.contact-theme-select-trigger:focus-visible {\n  border: 2px solid var(--interactive-default, #0f766e);\n  padding-inline: 11px 9px;\n  box-shadow: none;\n}\n\n.contact-theme-select-trigger span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.contact-theme-select-trigger svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  transition: transform 0.15s ease;\n}\n\n.contact-theme-select.is-open .contact-theme-select-trigger svg {\n  transform: rotate(180deg);\n}\n\n.contact-theme-select-menu {\n  position: absolute;\n  z-index: 50;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 240px;\n  padding: 6px;\n  overflow-y: auto;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 6px 16px -4px rgba(14, 26, 32, 0.16),\n    0 1px 2px rgba(14, 26, 32, 0.06);\n}\n\n.contact-theme-select-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 36px;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n}\n\n.contact-theme-select-option:hover,\n.contact-theme-select-option.is-active,\n.contact-theme-select-option.is-selected,\n.contact-theme-select-option:focus-visible {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n\n.contact-theme-select-option svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n\n.add-contact-input:focus,\n.add-contact-select:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n.add-contact-input::placeholder {\n  color: var(--text-disabled, #8a9896);\n}\n\n.add-contact-textarea {\n  min-height: 118px;\n  padding: 12px;\n  border-radius: 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background-color: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  resize: vertical;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.add-contact-textarea:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n\n/* Error States (Figma 1591:151187) */\n.add-contact-input.has-error,\n.add-contact-select.has-error,\n.add-contact-textarea.has-error {\n  border-color: var(--danger-default, #c23a2b) !important;\n}\n\n.add-contact-error-msg {\n  margin: 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--danger-default, #c23a2b);\n}\n\n/* Switch Toggle (Billing Section) */\n.add-contact-toggle-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n  height: 28px;\n}\n\n.add-contact-reminders {\n  width: 300px;\n  gap: 4px;\n}\n\n.add-contact-reminders .add-contact-label {\n  color: var(--text-secondary, #506360);\n  line-height: 16.9px;\n}\n\n.add-contact-toggle-switch {\n  position: relative;\n  width: 40px;\n  height: 22px;\n  background-color: var(--border-default, #cdd6d4);\n  border-radius: 999px;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.add-contact-toggle-switch.is-on {\n  background-color: var(--interactive-default, #0f766e);\n}\n\n.add-contact-toggle-thumb {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  transition: transform 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.add-contact-toggle-switch.is-on .add-contact-toggle-thumb {\n  transform: translateX(18px);\n}\n\n.add-contact-toggle-label {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--text-primary, #142624);\n}\n\n/* Address Accordion Disclosure */\n.add-contact-accordion-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 0;\n  background: transparent;\n  border: none;\n  color: var(--text-primary, #142624);\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  width: 100%;\n}\n\n.add-contact-accordion-header::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  margin-left: 4px;\n  background: var(--border-subtle, #dce3e2);\n}\n\n.add-contact-accordion-header:hover {\n  color: var(--interactive-default, #0f766e);\n}\n\n.add-contact-accordion-header svg {\n  font-size: 18px;\n  transition: transform 0.2s ease;\n}\n\n.add-contact-accordion-header.expanded svg {\n  transform: rotate(90deg);\n}\n\n/* Manual Address Panel (1569:88250) */\n.add-contact-manual-address-panel {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n  padding: 18px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 4px;\n}\n\n/* Logo Upload & Preview */\n.add-contact-logo-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.add-contact-logo-preview {\n  width: 75px;\n  height: 75px;\n  border-radius: 12px;\n  border: 1px dashed var(--border-default, #cdd6d4);\n  background-color: var(--surface-secondary, #f4f7f7);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  overflow: hidden;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.add-contact-logo-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.add-contact-logo-placeholder-icon {\n  width: 24px;\n  height: 24px;\n  color: var(--text-disabled, #8a9896);\n}\n\n.add-contact-logo-placeholder-text {\n  font-size: 11px;\n  color: var(--text-secondary, #506360);\n}\n\n.add-contact-logo-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.add-contact-logo-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.add-contact-logo-hint {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text-secondary, #506360);\n}\n\n/* Buttons */\n.add-contact-btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  background-color: var(--surface-primary, #ffffff);\n  color: var(--text-primary, #142624);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.15s ease;\n}\n\n.add-contact-btn-cancel:hover {\n  background-color: var(--surface-tertiary, #e8edec);\n  border-color: var(--border-strong, #8b9996);\n  color: var(--text-primary, #142624);\n}\n\n.add-contact-btn-save,\n.add-contact-btn-save:link,\n.add-contact-btn-save:visited {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: none;\n  background-color: var(--interactive-default, #0f766e);\n  color: #ffffff !important;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.15s ease;\n}\n\n.add-contact-btn-save:hover {\n  background-color: var(--interactive-hover, #0a655f);\n  color: #ffffff !important;\n}\n\n.add-contact-btn-save:active {\n  background-color: var(--interactive-pressed, #084f4b);\n  color: #ffffff !important;\n}\n\n.add-contact-btn-save svg {\n  color: #ffffff !important;\n  stroke: #ffffff !important;\n}\n\n/* Dark mode button themes */\n.add-contact-page.dark .add-contact-btn-save,\n.add-contact-page[data-theme=\"dark\"] .add-contact-btn-save {\n  background-color: var(--interactive-default, #43a79c);\n  color: #101113 !important;\n  font-weight: 600;\n}\n\n.add-contact-page.dark .add-contact-btn-save svg,\n.add-contact-page[data-theme=\"dark\"] .add-contact-btn-save svg {\n  color: #101113 !important;\n  stroke: #101113 !important;\n}\n\n.add-contact-page.dark .add-contact-btn-save:hover,\n.add-contact-page[data-theme=\"dark\"] .add-contact-btn-save:hover {\n  background-color: var(--interactive-hover, #83c7be);\n  color: #101113 !important;\n}\n\n.add-contact-page.dark .add-contact-btn-save:active,\n.add-contact-page[data-theme=\"dark\"] .add-contact-btn-save:active {\n  background-color: var(--interactive-pressed, #b6ded8);\n  color: #101113 !important;\n}\n\n.add-contact-page.dark .add-contact-btn-cancel {\n  background-color: var(--surface-primary, #191b1f);\n  border-color: var(--border-default, #3a3f47);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.add-contact-page.dark .add-contact-btn-cancel:hover,\n.add-contact-page[data-theme=\"dark\"] .add-contact-btn-cancel:hover {\n  background-color: var(--surface-tertiary, #2b2f35);\n  border-color: var(--border-strong, #69727e);\n  color: var(--text-primary, #f2f3f5);\n}\n\n.add-contact-btn-save:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* Spinner for button loading */\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.35);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Duplicate Contact Modal (1591:151462) */\n.duplicate-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: var(--overlay-default, rgba(10, 22, 20, 0.44));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 16px;\n}\n\n.duplicate-modal-dialog {\n  background-color: var(--surface-primary, #ffffff);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 20px;\n  width: 100%;\n  max-width: 520px;\n  box-shadow: 0px 6px 8px rgba(14, 26, 32, 0.1),\n    0px 1px 1px rgba(14, 26, 32, 0.04);\n  overflow: hidden;\n  animation: modalFadeIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.duplicate-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 28px 28px 20px;\n}\n\n.duplicate-modal-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.duplicate-modal-icon {\n  font-size: 24px;\n  color: var(--warning-default, #b7701a);\n  display: flex;\n}\n\n.duplicate-modal-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary, #142624);\n}\n\n.duplicate-modal-close {\n  border: none;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  padding: 4px;\n  border-radius: 6px;\n}\n\n.duplicate-modal-divider {\n  height: 1px;\n  background-color: var(--border-subtle, #dce3e2);\n  width: 100%;\n}\n\n.duplicate-modal-body {\n  padding: 24px 28px 0;\n}\n\n.duplicate-modal-body p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--text-secondary, #506360);\n}\n\n.duplicate-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 28px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1024px) {\n  .add-contact-page .dashboard-main {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 900px) {\n  .add-contact-card {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .add-contact-card-intro {\n    width: 100%;\n  }\n  .add-contact-field-group.w-532,\n  .add-contact-field-group.w-260,\n  .add-contact-field-group.w-160 {\n    width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .add-contact-content {\n    padding: 20px 16px 112px;\n  }\n\n  .add-contact-header {\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n\n  .add-contact-title-row {\n    align-items: flex-start;\n  }\n\n  .add-contact-title {\n    font-size: 20px;\n    line-height: 26px;\n    letter-spacing: -0.2px;\n  }\n\n  .add-contact-actions {\n    position: fixed;\n    z-index: 20;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    gap: 12px;\n    padding: 16px 24px 28px;\n    border-top: 1px solid var(--border-subtle, #dce3e2);\n    background: var(--surface-primary, #fff);\n  }\n\n  .add-contact-actions .add-contact-btn-cancel {\n    flex: 0 0 100px;\n  }\n\n  .add-contact-actions .add-contact-btn-save {\n    flex: 1;\n  }\n\n  .add-contact-form {\n    gap: 16px;\n  }\n\n  .add-contact-card {\n    gap: 16px;\n    padding: 20px;\n    border-radius: 10px;\n  }\n\n  .add-contact-card-fields,\n  .add-contact-field-row {\n    gap: 16px;\n  }\n\n  .add-contact-rcti-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .add-contact-abr-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .add-contact-field-group > .add-contact-abr-actions .add-contact-btn-save,\n  .add-contact-field-group > .add-contact-abr-actions .add-contact-abr-link {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .add-contact-field-group,\n  .add-contact-field-group.w-532,\n  .add-contact-field-group.w-260,\n  .add-contact-field-group.w-200,\n  .add-contact-field-group.w-160,\n  .add-contact-field-group.flex-1 {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .duplicate-modal-overlay,\n  .contact-modal-overlay {\n    align-items: flex-end;\n    padding: 64px 0 0;\n    background: var(--overlay-default, rgba(0, 0, 0, 0.6));\n  }\n\n  .duplicate-modal-dialog,\n  .contact-modal-dialog {\n    position: relative;\n    max-width: none !important;\n    min-height: 350px;\n    border: 0;\n    border-radius: 20px 20px 0 0;\n  }\n\n  .duplicate-modal-dialog::before,\n  .contact-modal-dialog::before {\n    content: \"\";\n    position: absolute;\n    z-index: 1;\n    top: 8px;\n    left: 50%;\n    width: 40px;\n    height: 4px;\n    border-radius: 999px;\n    background: var(--border-subtle, #dce3e2);\n    transform: translateX(-50%);\n  }\n\n  .duplicate-modal-header,\n  .contact-modal-header {\n    min-height: 80px;\n    padding: 20px 24px 0;\n    border-bottom: 1px solid var(--border-subtle, #dce3e2);\n  }\n\n  .duplicate-modal-title {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22.4px;\n    letter-spacing: -0.08px;\n  }\n\n  .duplicate-modal-icon {\n    font-size: 24px;\n  }\n\n  .duplicate-modal-divider {\n    display: none;\n  }\n\n  .duplicate-modal-body,\n  .contact-modal-body {\n    min-height: 102px;\n    padding: 18px 24px;\n  }\n\n  .duplicate-modal-body p,\n  .contact-modal-body p {\n    font-size: 13px;\n    line-height: 20.2px;\n  }\n\n  .duplicate-modal-footer,\n  .contact-modal-footer {\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px 24px 28px;\n    border-top: 1px solid var(--border-subtle, #dce3e2);\n  }\n\n  .duplicate-modal-footer > *,\n  .contact-modal-footer > * {\n    width: 100%;\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
